<div class="eletronic-signature">
  <div class="header">
    <div class="title" mat-dialog-title>{{ title }}</div>
    <div class="close-btn">
      <mat-icon (click)="close()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <div class="spinner" *ngIf="loading">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div class="component-error" *ngIf="!loading && componentError">
    Erro ao iniciar assinatura eletronica, por favor tente novamente, caso o problema persista, entre em contato
    conosco.
  </div>
  <app-virtual-keyboard *ngIf="!loading && !componentError" (onKeyChange)="onKeyChange($event)"
    (onError)="onComponentError($event)" (onReady)="onComponentReady($event)"
    [typeSignature]="this.selectedEletronicSignatureType">
  </app-virtual-keyboard>
  <div class="row action-btn" [ngClass]="{'virtual': selectedEletronicSignatureType !== 'string'}" *ngIf="!loading">
    <div class="col-9">
      <button mat-raised-button class="sm" color="primary02" (click)="confirm()"
        [disabled]="loadingComponent || componentError || eletronicSignature?.keys?.length < maxChar">{{confirmText}}</button>
    </div>
    <div class="col-3 p-0 box-check">
      <mat-checkbox class="mr-1" [(ngModel)]="saveSignature" name="checkSignatureFlag"
        [disabled]="!validSignature && eletronicSignature?.keys?.length < maxChar">Gravar
      </mat-checkbox>
    </div>
  </div>
  <div class="forgot-btn" *ngIf="!loading && selectedEletronicSignatureType === 'string'">
    <span (click)="forgot()">esqueci meu código de segurança</span>
  </div>
</div>